export const enabledIncompleteBookingApps = ["salesforce"];
